<template>
    <transition name="fade">
        <div class="shipped-back">
            <div class="back-container">
                <Icon type="md-close" class="close-btn" @click="close" />
                <div class="pop-title">填写退货物流单号</div>
                <div class="pop-body">
                    <div class="goods-info">
                        <img :src="goods.product_image|default_img" alt="" class="goods-img" />
                        <div class="info-box">
                            <div class="title">{{ goods.product_name }}</div>
                            <div class="spec">{{ goods.spec_info }}</div>
                            <div class="price">¥{{ (goods.price * goods.quantity) | price_format }}</div>
                        </div>
                    </div>
                    <div class="logistics-box">
                        <div class="company-no-box">
                            <div class="box-item">
                                <div class="label">物流公司</div>
                                <div class="value">
                                    <Select placeholder="请选择物流公司" v-model="form.logistics_id">
                                        <Option v-for="(item,index) in logistics_company_list" :key="index" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </div>
                            </div>
                            <div class="box-item">
                                <div class="label">运单号</div>
                                <div class="value">
                                    <Input v-model="form.logistics_no" placeholder="请输入运单号" />
                                </div>
                            </div>
                        </div>
                        <div class="remark">
                            <div class="remark-label">退货说明</div>
                            <div class="remark-value">
                                <Input v-model="form.change_memo" type="textarea" placeholder="请输入退货说明" class="input-item"/>
                            </div>
                        </div>
                        <div class="img-box" v-if="false">
                        <div class="img-label">上传图片</div>
                        <div class="img-list">
                            <div class="img-item" v-viewer v-for="(item,index) in form.user_proof" :key="index">
                                    <img :src="item|default_img" alt="" />
                                    <Icon @click.stop="onProofDel(index)" type="ios-close-circle" class="close-ico" size="20" />
                                </div>
                                <Upload action="/" :before-upload="onBeforeUpload" multiple>
                                    <div class="upload-btn">
                                        <img src="@/assets/images/icon-upload.png" alt="" class="upload-ico">
                                        <div class="upload-main-text">上传图片</div>
                                        <div class="upload-sub-text">(最多10张)</div>
                                    </div>
                                </Upload>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <div class="btn cancel" @click="close">取消</div>
                    <div class="btn confirm" @click="onSendBack">确认提交</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { AfterSaleReturn, logisticsCompanyList } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
export default{
    name:"ServiceShippedBack",
    props:{
        goods:{
            type:Object,
            default(){
                return {}
            }
        },
        uuid:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            form:{
                logistics_id:"",
                logistics_no:"",
                change_memo:""
            },
            logistics_company_list:[
            ]
        }
    },
    mounted(){
        this.onGetLogisticsCompanyList();
    },
    methods:{
        async onSendBack(){
            try{
                const {code,msg,data} = await AfterSaleReturn({...this.form,uuid:this.uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data',data);
                this.$emit('send-back');
                this.close();
            }catch(e){
                console.log('err-send-back',e);
                this.$layer.msg(e.msg);
            }
        },
        onBeforeUpload(file){
            uploadFileToOSS(file).then(res=>{
                const {code,data} = res;
                if(code > 0){
                    this.$layer.msg("图片上传失败");
                    return;
                }
                this.form.user_proof.push(data);
            }).catch(e=>{
                console.log('err-upload-file',e);
                this.$layer.msg("图片上传失败");
                return false;
            })
            return false;
        },
        async onGetLogisticsCompanyList(){
            try{
                const {code,msg,data} = await logisticsCompanyList();
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('logistics-company-list',data);
                this.logistics_company_list = data;
            }catch(e){
                console.log('err-logistics-company-list',e);
            }

        },
        close(){
            this.$emit("close");
        }
    }
}
</script>
<style lang="scss" scoped>
.shipped-back{
    width:100%;
    height:100%;
    position:fixed;
    background:rgba(0,0,0,0.5);
    top:0;
    left:0;
    z-index:110;
    display:flex;
    align-items:center;
    justify-content:center;
    .back-container{
        width:920px;
        background:#fff;
        border-radius:10px;
        position:relative;
        .close-btn{
            position:absolute;
            top:14px;
            right:16px;
            width:18px;
            height:18px;
            font-size:18px;
            cursor:pointer;
        }
        .pop-title{
            width:100%;
            text-align:center;
            padding:17px 0 13px 0;
            border-bottom:1px solid #e3e3e3;
            color:#0f1115;
            font-size:18px;
            font-weight:bold;
        }
        .pop-body{
            padding:32px 34px;
            display:flex;
            flex-direction:column;
            .goods-info{
                display:flex;
                align-items:center;
                column-gap:20px;
                .goods-img{
                    width:96px;
                    height:96px;
                    object-fit:cover;
                    border-radius:8px;
                }
                .info-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:15px;
                    .title{
                        color:#333;
                        font-size:16px;
                    }
                    .spec{
                        color:#666;
                        font-size:14px;
                    }
                    .price{
                        color:#ff5000;
                        font-size:16px;
                        font-weight:bold;
                    }
                }
            }
            .logistics-box{
                    width:100%;
                    margin-top:13px;
                    // background:#f6f7f9;
                    border-radius:4px;
                    // padding:20px 10px;
                    margin-bottom:20px;
                    margin-top:46px;
                    .company-no-box{
                        width:100%;
                        display:flex;
                        align-items:center;
                        column-gap:22px;
                        .box-item{
                            display:flex;
                            align-items:center;
                            column-gap:8px;
                            flex:1;
                            flex-shrink:0;
                            .label{
                                color:#333;
                                font-size:14px;
                                flex-shrink:0;
                                &::after{
                                    content:"*";
                                    color:red;                                    
                                }
                            }
                            .value{
                                flex:1;
                            }
                        }
                    }
                    .remark{
                        display:flex;
                        column-gap:8px;
                        margin-top:20px;
                        .remark-label{
                            color:#333;
                            font-size:14px;
                            flex-shrink:0;
                        }
                        .remark-value{
                            flex:1;
                            flex-shrink:0;
                            padding-left:5px;
                        }
                    }
                }
                .img-box{
                    display:flex;
                    align-items:center;
                    column-gap:15px;
                    margin-top:32px;
                    .img-label{
                        color:#333;
                        font-size:14px;
                    }
                    .img-list{
                            display:flex;
                            column-gap:12px;
                            .img-item{
                                width:110px;
                                height:110px;
                                position:relative;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                                .close-ico{
                                    position: absolute;
                                    top:0;
                                    right:0;
                                    width:20px;
                                    height:20px;
                                    cursor:pointer;
                                }
                            }
                            .upload-btn{
                                width:110px;
                                height:110px;
                                border:1px dashed #e3e3e3;                                
                                display:flex;
                                justify-content:center;
                                align-items:center;
                                flex-direction:column;
                                cursor:pointer;
                                background:#f8f9fb;
                                .upload-ico{
                                    width:24px;
                                    height:24px;
                                }
                                .upload-main-text,.upload-sub-text{
                                    color:#999;
                                    font-size:12px;
                                }
                            }
                        }
                }
                
        }
        .btn-box{
            width:100%;
            padding:18px 0 22px 0;
            display:flex;
            justify-content:center;
            align-items:center;
            column-gap:10px;
            border-top:1px solid #e3e3e3;
            .btn{
                padding:10px 40px;
                cursor:pointer;
                font-size:14px;
                font-weight:bold;
                border-radius:4px;
                &.cancel{
                    border:1px solid #e3e3e3;
                    color:#666;
                }
                &.confirm{
                    background:#ff5967;
                    color:#fff;
                }
            }
        }
    }
}
</style>